import { Request, Response } from "express"

import { getIngredients, addIngredients, patchIngredients } from "#services/recipe/ingredients"

export const getRecipeIngredients = async (req: Request, res: Response) => {
	const list = await getIngredients({
		id: req.params.recipeID,
	})

	res.json(list)
}
export const addRecipeIngredients = async (req: Request, res: Response) => {
	const results = await addIngredients(req.body)

	if (results.error && results.error.errno && results.error.errno > 0) {
		res.status(500).send(results)
	} else {
		res.send(req.body)
	}
}
export const updateRecipeIngredients = async (req: Request, res: Response) => {
	const results = await patchIngredients(req.body)

	if (results.error && results.error.errno && results.error.errno > 0) {
		res.status(500).send(results)
	} else {
		res.send(req.body)
	}
}
